var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-home-slide',{attrs:{"loading":_vm.loading}},[(_vm.hasData)?_c('div',{staticClass:"h-full w-full"},[_c('calculation-row',{attrs:{"calculations":_vm.calculations}}),_c('gdt-row',{attrs:{"gdt":_vm.gdt}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }